(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2866],{

/***/ 4828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_FundOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/FundOutlined.js
// This icon file is generated automatically.
var FundOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L531 565 416.6 450.5a8.03 8.03 0 00-11.3 0l-214.9 215a8.03 8.03 0 000 11.3l36.7 36.9z" } }] }, "name": "fund", "theme": "outlined" };
/* harmony default export */ var asn_FundOutlined = (FundOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 5 modules
var AntdIcon = __webpack_require__(89099);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/FundOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var FundOutlined_FundOutlined = function FundOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_FundOutlined
  }));
};
FundOutlined_FundOutlined.displayName = 'FundOutlined';
/* harmony default export */ var icons_FundOutlined = (/*#__PURE__*/react.forwardRef(FundOutlined_FundOutlined));

/***/ }),

/***/ 22111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _country_slug_; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/home/AboveFooter.js
var AboveFooter = __webpack_require__(13464);
// EXTERNAL MODULE: ./components/home/Banner3.tsx + 1 modules
var Banner3 = __webpack_require__(29078);
// EXTERNAL MODULE: ./components/home/CommentsSection.tsx
var CommentsSection = __webpack_require__(6228);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/FundOutlined.js + 1 modules
var FundOutlined = __webpack_require__(4828);
// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 20 modules
var typography = __webpack_require__(51945);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/card/index.js + 17 modules
var card = __webpack_require__(3679);
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/home/IposSection.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var Text = typography/* default.Text */.Z.Text;

var dataSource = function dataSource() {
  return {
    wrapper: {
      className: 'home-page-wrapper commentSection-wrapper'
    },
    page: {
      className: 'home-page commentSection'
    },
    OverPack: {
      playScale: 0.3
    },
    titleWrapper: {
      className: 'commentSection-title-wrapper',
      children: [{
        name: 'title',
        className: 'commentSection-title-h1',
        children: 'Latest IPOs'
      }]
    }
  };
};

function IpoSection(props) {
  var ipos = props.ipos;
  var dataSourceWithBrokers = dataSource();
  var titleWrapper = dataSourceWithBrokers.titleWrapper;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({}, dataSourceWithBrokers.wrapper), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", _objectSpread(_objectSpread({}, dataSourceWithBrokers.page), {}, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({}, dataSourceWithBrokers.titleWrapper), {}, {
        children: titleWrapper.children.map(util/* getChildrenToRender */.TU)
      })), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        gutter: [150, 56],
        children: ipos.map(function (item, i) {
          var _item$attributes$desc;

          return /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
            xs: 24,
            lg: 12,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(card/* default */.Z, {
              headStyle: {
                background: '#E6F7FF'
              },
              title: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FundOutlined/* default */.Z, {}), " ", item.attributes.name]
              }),
              type: "inner",
              style: {
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
                  children: (_item$attributes$desc = item.attributes.description) === null || _item$attributes$desc === void 0 ? void 0 : _item$attributes$desc.slice(0, 120)
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  "float": 'right'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(util/* NextLink */.pt, {
                  href: "/ipos/".concat(item.attributes.slug),
                  children: [item.attributes.name, " IPO Details"]
                })
              })]
            }, i)
          }, i);
        })
      })]
    }))
  }));
}

/* harmony default export */ var IposSection = (IpoSection);
// EXTERNAL MODULE: ./components/home/PopularQuestions.tsx
var PopularQuestions = __webpack_require__(56265);
// EXTERNAL MODULE: ./components/home/data.source.js
var data_source = __webpack_require__(49091);
// EXTERNAL MODULE: ./layouts/application.tsx + 4 modules
var application = __webpack_require__(8182);
;// CONCATENATED MODULE: ./pages/[country_slug].tsx
/* eslint no-undef: 0 */

/* eslint arrow-parens: 0 */












var description = function description() {
  return "A Personal Finance FAQ portal for India, Canada & USA investors. Financial education hub sharing broker\nreviews, stock market queries, trading & investment software and apps.";
};

var Home = function Home(props) {
  var isMobile = props.isMobile,
      data = props.data;
  var router = (0,next_router.useRouter)();
  var country_slug = router.query.country_slug;
  var allBrokers = data.all_brokers,
      LatestComments = data.latest_comments,
      allPages = data.all_pages.data,
      _data$latest_ipos = data.latest_ipos;
  _data$latest_ipos = _data$latest_ipos === void 0 ? {
    data: []
  } : _data$latest_ipos;
  var LatestIpos = _data$latest_ipos.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(application/* default */.Z, {
    allBrokers: allBrokers.data,
    navCalculators: [],
    allPages: allPages,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Finance Education Hub: Financial FAQs - Fintrakk"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: description()
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "templates-wrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner3/* default */.Z, {
        id: "Banner3_0",
        dataSource: data_source/* default */.Z,
        isMobile: isMobile
      }, "Banner3_0"), /*#__PURE__*/(0,jsx_runtime.jsx)(PopularQuestions/* default */.Z, {
        id: "Feature7_0",
        isMobile: isMobile,
        articles: data
      }, "Feature7_0"), country_slug === 'us' && LatestIpos.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(IposSection, {
        id: "comments_section",
        isMobile: isMobile,
        ipos: LatestIpos
      }, "comments_section"), LatestComments.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(CommentsSection/* default */.Z, {
        id: "comments_section",
        isMobile: isMobile,
        comments: LatestComments
      }, "comments_section"), /*#__PURE__*/(0,jsx_runtime.jsx)(AboveFooter/* default */.Z, {
        id: "Feature7_0",
        isMobile: isMobile
      }, "Feature7_0"), ","]
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ var _country_slug_ = (Home);

/***/ }),

/***/ 3820:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country_slug]",
      function () {
        return __webpack_require__(22111);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,7752,2913,1945,2682,7527,6873,3679,2139,8195,5001,8182,3492,7484,9774,2888,179], function() { return __webpack_exec__(3820); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);